import script from "./FriendLink.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendLink.vue?vue&type=script&setup=true&lang=js"

import "./FriendLink.vue?vue&type=style&index=0&id=e258ce9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e258ce9a"]])

export default __exports__